export default "__VITE_ASSET__3K5SxucW__"